export default ".rttd-app {\n  margin-top: 24px;\n}\n\n@media (min-width: 769px) {\n  .container {\n    max-width: 1120px;\n  }\n}"